import vue from "../main";

export const delegationDocumentViewTypes = () => [
  {
    value: "standard_pl",
    text: vue.$t("$staticData.delegationDocumentViews.standardPl")
  },
  {
    value: "standard_pl_en",
    text: vue.$t("$staticData.delegationDocumentViews.standardPlEn")
  },
  {
    value: "summary_last_exclude_payed_by_company_pl_en",
    text: vue.$t("$staticData.delegationDocumentViews.summaryLastExcludePayedByCompanyPlEn")
  },
  {
    value: "summary_last_exclude_bookings_pl_en",
    text: vue.$t("$staticData.delegationDocumentViews.summaryLastExcludeBookingsPlEn")
  },
  {
    value: "summary_only_exclude_bookings_pl_en",
    text: vue.$t("$staticData.delegationDocumentViews.summaryOnlyExcludeBookingsPlEn")
  }
];

export const verifyDistance = () => [
  {
    value: 1,
    text: vue.$t("$staticData.settingsTypes.verifyDistance.noVerify")
  },
  // {value: 2, text: "Wyświetlenie ostrzeżenia"},
  {
    value: 3,
    text: vue.$t("$staticData.settingsTypes.verifyDistance.commentRequired")
  },
  {
    value: 4,
    text: vue.$t("$staticData.settingsTypes.verifyDistance.blockSave")
  },
  { value: 0, text: vue.$t("$staticData.settingsTypes.revertDefaultValue") }
];

export const delegationNumberSettingType = () => [
  {
    value: 1,
    text: vue.$t("$staticData.settingsTypes.delegationNumberSettingType.manually")
  },
  {
    value: 2,
    text: vue.$t("$staticData.settingsTypes.delegationNumberSettingType.autoEditable")
  },
  {
    value: 3,
    text: vue.$t("$staticData.settingsTypes.delegationNumberSettingType.autoOnly")
  },
  { value: 0, text: vue.$t("$staticData.settingsTypes.revertDefaultValue") }
];

export const delegationNumberDate = () => [
  {
    value: 1,
    text: vue.$t("$staticData.settingsTypes.delegationNumberDate.create")
  },
  {
    value: 2,
    text: vue.$t("$staticData.settingsTypes.delegationNumberDate.start")
  },
  {
    value: 3,
    text: vue.$t("$staticData.settingsTypes.delegationNumberDate.end")
  },
  {
    value: 4,
    text: vue.$t("$staticData.settingsTypes.delegationNumberDate.sendToAccept")
  },
  {
    value: 5,
    text: vue.$t("$staticData.settingsTypes.delegationNumberDate.accept")
  },
  { value: 0, text: vue.$t("$staticData.settingsTypes.revertDefaultValue") }
];

export const settingTypes = Object.freeze({
  REQUIRED: 2,
  OPTIONAL: 1,
  NOT_REQUIRED: 1,
  NOT_AVAILABLE: 3,
  DEFAULT_VALUE: 0
});

export const delegationOrderRequiredOption = () => [
  {
    value: 1,
    text: vue.$t("$staticData.settingsTypes.delegationOrderRequiredOption.disabled")
  },
  {
    value: 2,
    text: vue.$t("$staticData.settingsTypes.delegationOrderRequiredOption.optional")
  },
  {
    value: 3,
    text: vue.$t("$staticData.settingsTypes.delegationOrderRequiredOption.required")
  },
  { value: 0, text: vue.$t("$staticData.settingsTypes.revertDefaultValue") }
];

export const delegationFromOrderDateValidationType = () => [
  {
    value: 1,
    text: vue.$t("$staticData.settingsTypes.delegationFromOrderDateValidationType.noValidation")
  },
  {
    value: 2,
    text: vue.$t("$staticData.settingsTypes.delegationFromOrderDateValidationType.equals")
  },
  {
    value: 3,
    text: vue.$t("$staticData.settingsTypes.delegationFromOrderDateValidationType.day")
  },
  {
    value: 4,
    text: vue.$t("$staticData.settingsTypes.delegationFromOrderDateValidationType.1hour")
  },
  {
    value: 5,
    text: vue.$t("$staticData.settingsTypes.delegationFromOrderDateValidationType.3hour")
  },
  {
    value: 6,
    text: vue.$t("$staticData.settingsTypes.delegationFromOrderDateValidationType.6hour")
  },
  {
    value: 7,
    text: vue.$t("$staticData.settingsTypes.delegationFromOrderDateValidationType.12hour")
  },
  {
    value: 8,
    text: vue.$t("$staticData.settingsTypes.delegationFromOrderDateValidationType.24hour")
  },
  {
    value: 9,
    text: vue.$t("$staticData.settingsTypes.delegationFromOrderDateValidationType.48hour")
  },
  { value: 0, text: vue.$t("$staticData.settingsTypes.revertDefaultValue") }
];

export const delegationFromOrderDateValidation = () => [
  {
    value: 1,
    text: vue.$t("$staticData.settingsTypes.delegationFromOrderDateValidation.noValidation")
  },
  {
    value: 2,
    text: vue.$t("$staticData.settingsTypes.delegationFromOrderDateValidation.commentRequired")
  },
  {
    value: 3,
    text: vue.$t("$staticData.settingsTypes.delegationFromOrderDateValidation.blockSave")
  },
  { value: 0, text: vue.$t("$staticData.settingsTypes.revertDefaultValue") }
];

export const documentLanguage = () => [
  { value: 0, text: vue.$t("$staticData.settingsTypes.revertDefaultValue") },
  {
    value: 1,
    text: vue.$t("$staticData.settingsTypes.documentLanguage.polish")
  },
  {
    value: 2,
    text: vue.$t("$staticData.settingsTypes.documentLanguage.biLang")
  }
];
